"use client";

import type { ElementType, FC, Ref } from "react";
import { mergeClasses } from "@huub-web/utils";
import type { RecipeVariants } from "@vanilla-extract/recipes";

import { baseContainerStyle } from "./Container.css";
import type { ChildrenProp } from "../../props/ChildrenProp";
import type { ClassNameProp } from "../../props/ClassNameProp";
import { Flex, type FlexProps } from "../Flex/Flex";

export type ContainerProps = FlexProps &
  RecipeVariants<typeof baseContainerStyle> &
  ClassNameProp &
  ChildrenProp & {
    grow?: boolean;
    as?: ElementType;
    stretch?: boolean;
    /**
     * Ref forwarded to the root element
     */
    ref?: Ref<HTMLDivElement>;
  };

/**
 * Contains the main content of the application.
 */
export const Container: FC<ContainerProps> = ({
  as = "div",
  variant,
  size = "default",
  grow = false,
  direction = "column",
  children,
  gap,
  stretch = false,
  className,
  ref,
  ...props
}) => (
  <Flex
    ref={ref}
    as={as}
    className={mergeClasses(
      "container",
      baseContainerStyle({ size, variant, grow, stretch, gap }),
      className,
    )}
    direction={direction}
    {...props}
  >
    {children}
  </Flex>
);
